import { Component } from '@angular/core';
import { TooltipTextComponent } from '../common/tooltip-text/tooltip-text.component';

@Component({
  selector: 'app-tooltip-page',
  templateUrl: './tooltip-page.component.html',
  styleUrls: ['./tooltip-page.component.scss']
})
export class TooltipPageComponent {

}
